import { render, staticRenderFns } from "./duoTileTitle.vue?vue&type=template&id=9e85a4e8&"
import script from "./duoTileTitle.vue?vue&type=script&lang=js&"
export * from "./duoTileTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports